import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import React from 'react';

import Text from 'commons/Text';
import Colors from 'configs/Colors';

const FooterLinks = ({ classes, t }) => (
  <div className={classes.footer}>
    <a
      href="#"
      className={classes.footerItem}
    >
      <Text
        type="md"
        fontWeightBold
        color={Colors.Grey10}
      >
        {t('manage_shared_links')}
      </Text>
      <KeyboardArrowRightRoundedIcon />
    </a>
  </div>
);

export default FooterLinks;
